<template>
    <title>Search Work Orders</title>

    <body v-if="!searchResult">
        <div class="header">
            <div class="title">
                <h2>Search Work Orders</h2>
            </div>

            <div class="subtitle">
                <h5 :company="company" :sortCode="sortCode">{{ company }} ({{ sortCode }})</h5>
            </div>
        </div>
        <div v-show="noResults" id="errorLogin" class="error" style="color: #red">
            The previous search found no records. Please try again.
        </div> 
        <div class="body" id="body" name="body">
            <div>
                <div id="requestForm" name="requestForm" style="width: 45.5%; float:left;">
                    <form method="post" name="searchOrders" id="searchOrders" action="<?php echo $searchURL.'?srcCrit=1'; ?>" class="submitForm">
                        <div class="label">
                            <h4 style="margin-bottom: 0px; margin-left: 3%">Search</h4>
                        </div>
                        <div>
                            <label for="requestor">Requestor</label>
                        </div>
                        <div>
                            <input type="text" name="requestor" id="requestor" class="standard" v-model="requestor" @keyup.enter="onSearch"/>
                        </div>
                        <div>
                            <label for="branch">Branch<span class="required"></span></label>
                        </div>
                        <div>
                            <input type="text" name="branch" id="branch" class="standard" v-model="branch" @keyup.enter="onSearch"/>
                        </div>  
                        <div>
                            <label for="lastName" style="width: 40%">Applicant Last Name<span class="required"></span></label><label for="firstName" style="width: 40%; margin-left: 2%; margin-right: 0px">Applicant First Name<span class="required"></span></label>
                        </div>
                        <div>
                            <input type="text" name="lastName" id="lastName" class="standard" style="width: 44%; margin-right: 0px" v-model="lastName" @keyup.enter="onSearch"/>
                            <input type="text" name="firstName" id="firstName" class="standard" style="width: 45%; margin-right: 0px; margin-left: 1%" v-model="firstName" @keyup.enter="onSearch"/>
                        </div>
                        <div>
                            <label for="propertyAddress">Property Address</label>
                        </div>
                        <div>
                            <input type="text" name="propertyAddress" id="propertyAddress" class="standard" v-model="propertyAddress" @keyup.enter="onSearch"/>
                        </div>
                        <div>
                            <label for="city" style="width: 55%">City*</label><label for="state" style="width:10%; margin-left: 3%; margin-right: 0px">State*</label><label for="zip" style="width:10%; margin-left: 1%">Zip*</label>
                        </div>
                        <div>
                            <input type="text" name="city" id="city" class="standard" style="width: 60%; margin-right: 0px" v-model="city" @keyup.enter="onSearch"/>
                            <input type="text" name="state" id="state" class="standard" style="width: 10%; margin-right: 0px; margin-left: 1%" v-model="state" @keyup.enter="onSearch"/>
                            <input type="text" name="zip" id="zip" class="standard" style="width: 18%; margin-right: 0px; margin-left: 1%" v-model="zip" @keyup.enter="onSearch"/>
                        </div>
                        <div>
                            <label for="parcelNumber">Parcel Number<span class="required"></span></label>
                        </div>
                        <div>
                            <input type="text" name="parcelNumber" id="parcelNumber" class="standard" v-model="parcelNumber" @keyup.enter="onSearch"/>
                        </div>
                        <div>
                            <label for="commentsLegal">Comments/Legal<span class="required"></span></label>
                        </div>
                        <div>
                            <textarea name="commentsLegal" id="commentsLegal" class="standard" style="min-height: 64px; margin-left: 4%" v-model="commentsLegal" @keyup.enter="onSearch"/>
                        </div>
                        <div>
                            <label for="loanNumber">Loan Number<span class="required"></span></label>
                        </div>
                        <div>
                            <input type="text" name="loanNumber" id="loanNumber" class="standard" v-model="loanNumber" @keyup.enter="onSearch"/>
                        </div>
                        <div>
                            <label for="fciNum">FCI Number<span class="required"></span></label>
                        </div>
                        <div>
                            <input type="text" name="fciNum" id="fciNum" class="standard" v-model="fciNum" @keyup.enter="onSearch"/>
                        </div>
                        <div>
                            <button type="button" id="btnSearch" name="btnSearch" @click="onSearch">Search</button>
                        </div>
                        <div>
                            <input type="hidden" name="srcCrit" id="srcCrit" value="1" />
                        </div>
                    </form>
                </div>
                <div id="ordersAndFind" name="ordersAndFind"></div>
            </div>
            <div id="errorSubmit" class="required"></div>
        </div>
    </body>
    <body v-if="searchResult">
        <div class="header">
            <div class="title">
                <h2>Search Results</h2>
            </div>

            <div class="subtitle">
                <h5 :company="company" :sortCode="sortCode">{{ company }} ({{ sortCode }})</h5>
            </div>
        </div>

        <tw-table @no-results="setupNoResults" :query="query"></tw-table>
    </body>
</template>

<script>
    import { defineComponent, ref } from 'vue'
    import { useStore } from 'vuex'

    export default defineComponent({
        name: 'Search',
        setup() {
            const searchResult = ref(false)
            const query = ref([])

            const store = useStore()
            const requestor = ref('')
            const branch = ref('')
            const lastName = ref('')
            const firstName = ref('')
            const propertyAddress = ref('')
            const city = ref('')
            const state = ref('')
            const zip = ref('')
            const parcelNumber = ref('')
            const commentsLegal = ref('')
            const loanNumber = ref('')
            const fciNum = ref('')
            const company = store.state.user.company
            const sortCode = store.state.user.sortCode

            function onSearch(){
                query.value = [
                {
                    "Client": `=="${store.state.user.company}"`,
                    //"LL_Login_Date": dateRange,
                    "Requestor": requestor.value,
                    "Branch": branch.value,
                    "Prop_Applicant_Last": lastName.value,
                    "Prop_Applicant_First": firstName.value,
                    "Prop_Address": propertyAddress.value,
                    "Prop_City": city.value,
                    "Prop_State": state.value,
                    "Prop_Zip": zip.value,
                    "Parcel_Number": parcelNumber.value,
                    "Short Legal Descript": commentsLegal.value,
                    "Loan_ID": loanNumber.value,
                    "FCI#": fciNum.value,
                }
                ]
                searchResult.value = true
            }

            const noResults = ref(false)
            function setupNoResults(){
                noResults.value = true
                searchResult.value = false
            }

            return {
                requestor,
                branch,
                lastName,
                firstName,
                propertyAddress,
                city,
                state,
                zip,
                parcelNumber,
                commentsLegal,
                loanNumber,
                fciNum,
                company,
                sortCode,
                searchResult,
                query,
                noResults,
                onSearch,
                setupNoResults,
            }
        }
    })
</script>

<style>
    button{
        width: 90% !important;
        height: 50px !important;
        margin-left: 4% !important;
        margin-right: 10% !important;
    }
    div.error{
        margin-left: 2%;
       font-weight: bold;
       color: red;
    }
</style>